// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".u-you-data_NcOuUHO1{position:relative;width:400px;height:600px;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:0;display:-webkit-box;display:-ms-flexbox;display:flex}.u-you-data_loading_NcOuUHO1:not(html){position:absolute}.u-you-data_frame_NcOuUHO1{position:absolute;top:0;left:0;right:0;bottom:0;padding:0;margin:auto;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);
// Exports
exports.locals = {
	"root": "u-you-data_NcOuUHO1",
	"loading": "u-you-data_loading_NcOuUHO1",
	"frame": "u-you-data_frame_NcOuUHO1"
};
module.exports = exports;
